import { Pagination as MUIPagination } from '@mui/material'
import { display, styled } from '@mui/system'

export const Pagination = styled(MUIPagination)(({ theme }) => ({
  '& .MuiPagination-ul': {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      gap: theme.spacing(2),
    },
  },
  '& .MuiPaginationItem-root': {
    margin: 0,
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.surface.A700,
    fontSize: '14px',
    '&:hover': {
      backgroundColor: theme.palette.primary[600],
    },

    '&.MuiPaginationItem-previousNext': {
      backgroundColor: 'transparent',
      color: theme.palette.surface[300],
    },

    '&.MuiPaginationItem-ellipsis': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'default',
      pointerEvents: 'none',
      width: '32px',
      height: '32px',

      [theme.breakpoints.up('sm')]: {
        borderRadius: '50%',
        width: '38px',
        height: '38px',
      },
    },

    '&.Mui-selected': {
      backgroundColor: theme.palette.primary[600],

      '&:hover': {
        backgroundColor: theme.palette.primary[600],
      },
    },
    [theme.breakpoints.up('sm')]: {
      borderRadius: '50%',
      width: '38px',
      height: '38px',
      fontSize: '16px',
    },
  },
}))

export const PaginationContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
}))
